module.exports = __webpack_public_path__ + "static/img/settle-bc1.982887ec.png";